import React, { ReactElement } from "react";
import styles from "./scrollingBanner.module.scss";
import { Colors } from "../../theme";
import classNames from "classnames";
import { LazyLoadedMarquee } from "@kunduz/utility-marquee";

export const ScrollingBanner = (props: Props): ReactElement => {
  return (
    <section
      className={classNames(styles.wrapper, styles[`theme-${props.theme}`])}
    >
      <LazyLoadedMarquee autoFill pauseOnHover>
        {props.lines.map((line, index) => (
          <div className={styles.marqueeItem} key={index}>
            <div className={styles.text}>{line}</div>
            {props.divider}
          </div>
        ))}
      </LazyLoadedMarquee>
    </section>
  );
};

interface Props {
  lines: string[];
  divider: any;
  theme: Colors;
}
